import { apiClient } from "../../../lib/axios";
import type { FaqItem } from "./types";

export interface GetFaqsParams {
  limit?: number;
  offset?: number;
  is_published?: boolean;
}

export const faqApi = {
  getFaqs: async ({
    limit = 50,
    offset = 0,
    is_published = true,
  }: GetFaqsParams = {}): Promise<FaqItem[]> => {
    const response = await apiClient.get<FaqItem[]>("/faq", {
      params: { limit, offset, is_published },
    });
    return response.data;
  },
};

